export const InvoiceStatusConstants = {
  SENT: '3a4ebba1-8660-495d-bfbb-3dbc094be8bc',
  INVOICED: 'e86ebc78-3f4f-4e2a-a977-7bf58e1a5ce0',
  CREATED: '2c63c57e-85b0-49e6-99e3-f4b032eebdb6',
} as const;

export type InvoiceStatusId =
  (typeof InvoiceStatusConstants)[keyof typeof InvoiceStatusConstants];
